import { Color, Vector4 } from "three";

export interface SkinTintColors {
  primary: string;
  secondary: string;
  tertiary: string;
  quaternary: string;
}

export function colorStringToVector(colorString: string) {
  const color = new Color(parseInt(colorString.replace("#", ""), 16));
  const array = color.toArray();
  return new Vector4(array[0], array[1], array[2], 1);
}

export function SkinTintColorsFromArray(hexStrings: string[]): SkinTintColors {
  // TODO: do we want to error here if hexStrings.length < 4?
  return {
    primary: hexStrings[0],
    secondary: hexStrings[1],
    tertiary: hexStrings[2] ?? hexStrings[0],
    quaternary:
      hexStrings[3] ?? (hexStrings[2] ? hexStrings[1] : hexStrings[0]),
  };
}
